var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clear",attrs:{"id":"quickNav"}},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"box left"},[_c('img',{staticClass:"photo",attrs:{"src":item.src}}),_c('div',{staticClass:"word"},[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }